export default __webpack_public_path__ + "static/media/zoomIn.eb50ac64.svg";